import MainGraph from './Component';

export default MainGraph;
